import Header from 'components/headers/funds'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import useGetRequestMessage from './hooks/useGetRequestMessage'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { useCallback } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

export default function MessagesPage() {
    const { requestMessage, isLoading, fetchNextPage } = useGetRequestMessage()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <>
            <Header title="پیام ها" />
            <SideBar>
                <SideBarItems />
            </SideBar>

            <InfiniteScroll
                hasMore={
                    requestMessage
                        ? requestMessage.pages[requestMessage?.pages.length - 1]
                              .last_date
                            ? true
                            : false
                        : false
                }
                next={onWatchEnd}
                dataLength={
                    requestMessage
                        ? requestMessage.pages.flatMap((x) => x.result).length
                        : 0
                }
                loader={<DotsLoading />}
            >
                <>
                    {requestMessage ? (
                        <>
                            {requestMessage.pages
                                .flatMap((x) => x.result)
                                .map((item, index) => (
                                    <Item item={item} key={index} />
                                ))}
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </>
            </InfiniteScroll>
        </>
    )
}
